import React, { lazy } from 'react';
export function MockupComparison() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-135">
      <div className="max-w-6xl mx-auto" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-138">
            La diferencia visual es clara
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-6 leading-tight" data-id="element-139">
            Básica vs Edición Profesional
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-end" data-id="element-140">
          {/* Básica */}
          <div className="flex flex-col items-center" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/w1FaxP4vjCZkpk4XumuSa9/mockup_sin_upsell_webp.webp" alt="Colección Básica" className="w-full max-w-md h-auto drop-shadow-xl mb-6" loading="lazy" decoding="async" data-id="element-142" />
            <div className="text-center" data-id="element-143">
              <h3 className="text-2xl font-bold text-gray-800" data-id="element-144">
                Colección Básica — 19.99€
              </h3>
              <p className="text-gray-600 font-medium mt-2" data-id="element-145">
                4 Tomos + 3 Bonos
              </p>
            </div>
          </div>

          {/* Profesional */}
          <div className="flex flex-col items-center" data-id="element-146">
            <div className="bg-yellow-100 text-yellow-800 px-4 py-1 rounded-full text-sm font-bold mb-4 flex items-center gap-1" data-id="element-147">
              ⭐ LA MÁS ELEGIDA
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/x16jfK3pzxKh6FsrusQ4Pb/mockup_upsell_webp.webp" alt="Edición Profesional" className="w-full max-w-lg h-auto drop-shadow-2xl mb-6 scale-105" loading="lazy" decoding="async" data-id="element-148" />
            <div className="text-center" data-id="element-149">
              <h3 className="text-2xl font-black text-blue-900 flex items-center justify-center gap-2" data-id="element-150">
                ⭐ Edición Profesional — 29.99€
              </h3>
              <p className="text-gray-700 font-bold mt-2" data-id="element-151">
                4 Tomos + 3 Bonos + Acelerador de Ingresos
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}